import type { ComponentType, KeyboardEvent } from 'react';
import { useSearchParams } from 'react-router-dom';
import { AccessTab } from './AccessTab';
import { AppearanceTab } from './AppearanceTab';
import { BackupTab } from './BackupTab';
import { HelpTab } from './HelpTab';
import { LimitsTab } from './LimitsTab';
import { NotificationsTab } from './NotificationsTab';
import { SETTINGS_TABS } from './nav';
import { ProfilesTab } from './ProfilesTab';
import { SupportTab } from './SupportTab';
import { UpdatesTab } from './UpdatesTab';

// Impostazioni a schede, come SurgeAI (tela, artboard 47): il titolo, le schede, una card con la
// scheda scelta. Ogni scheda legge e scrive il server o questo browser, e salva da sé.
const VIEWS: Record<string, ComponentType> = {
  general: AppearanceTab,
  limits: LimitsTab,
  profiles: ProfilesTab,
  sessions: AccessTab,
  updates: UpdatesTab,
  notifications: NotificationsTab,
  support: SupportTab,
  backup: BackupTab,
  help: HelpTab,
};

export function Settings() {
  const [params, setParams] = useSearchParams();
  const tab = VIEWS[params.get('tab') ?? ''] ? (params.get('tab') as string) : 'general';
  const View = VIEWS[tab];
  const choose = (id: string) => setParams({ tab: id }, { replace: true });

  // frecce, Home e Fine fra le schede, come in una tablist nativa
  const onKey = (e: KeyboardEvent<HTMLDivElement>) => {
    const i = SETTINGS_TABS.findIndex((t) => t.id === tab);
    const to =
      e.key === 'ArrowRight'
        ? (i + 1) % SETTINGS_TABS.length
        : e.key === 'ArrowLeft'
          ? (i - 1 + SETTINGS_TABS.length) % SETTINGS_TABS.length
          : e.key === 'Home'
            ? 0
            : e.key === 'End'
              ? SETTINGS_TABS.length - 1
              : -1;
    if (to < 0) return;
    e.preventDefault();
    choose(SETTINGS_TABS[to].id);
    document.getElementById(`settings-tab-${SETTINGS_TABS[to].id}`)?.focus();
  };

  return (
    <div className="page" style={{ display: 'grid', gap: 20, alignContent: 'start' }}>
      <h1 className="t-h1" style={{ margin: 0 }}>
        Impostazioni di PopTown
      </h1>
      <div className="settings-tabs" role="tablist" aria-label="Sezioni" onKeyDown={onKey}>
        {SETTINGS_TABS.map((t) => (
          <button
            key={t.id}
            id={`settings-tab-${t.id}`}
            type="button"
            role="tab"
            className="settings-tab"
            aria-selected={t.id === tab}
            aria-controls="settings-panel"
            tabIndex={t.id === tab ? 0 : -1}
            onClick={() => choose(t.id)}
          >
            {t.label}
          </button>
        ))}
      </div>
      <section
        id="settings-panel"
        role="tabpanel"
        aria-labelledby={`settings-tab-${tab}`}
        className="settings-card"
      >
        <View />
      </section>
    </div>
  );
}
